import { ESPConnection } from "../espConnection";
var MachineService = /** @class */ (function () {
    function MachineService(optsConnection) {
        this._connection = new ESPConnection(optsConnection, "ws_machine", "1.13");
    }
    MachineService.prototype.GetTargetClusterInfo = function (request) {
        if (request === void 0) { request = {}; }
        return this._connection.send("GetTargetClusterInfo", request);
    };
    return MachineService;
}());
export { MachineService };
//# sourceMappingURL=wsMachine.js.map